<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>高级功能</el-breadcrumb-item>
        <el-breadcrumb-item>远程数据</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
          <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addAgentBtn" :loading="state">添加远程数据</el-button>
        </el-card>
      </div>

      <el-form :inline="true" :model="addAgentForm" class="demo-form-inline" ref="agentRef" size="small" style="margin:20px 0">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="数据Key:" prop="key">
          <el-input v-model="queryInfo.key"  clearable placeholder="支持模糊查询"></el-input>
        </el-form-item>

        <el-button type="primary" size="small" @click="query" :loading="state" icon="el-icon-search">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state" icon="el-icon-refresh-left">重 置</el-button>
      </el-form>

      <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">*为防止滥用远程数据，变量，每个用户每月有50万次免费额度，超过的按 50万次/1元/月 计费，不足50万次的按50万次计算。</el-tag>
      <el-table :data="tableList" border style="width: 100%" stripe v-loading="loading">
        <el-table-column prop="softName" label="所属软件" width="200"></el-table-column>
        <el-table-column prop="key" label="数据key" width="170"></el-table-column>
        <el-table-column prop="value" label="数据值" width="170"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="170"></el-table-column>
        <el-table-column prop="updateDate" label="修改时间" width="170"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="integral(scope.row)">编 辑</el-button>
            <el-button @click="unbinding(scope.row)" size="mini" type="danger">删 除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加远程数据 -->
    <el-dialog title="添加远程数据" :close-on-click-modal="false" :visible.sync="addDialogVisible" :width="addAgentWidth" @close="closeAddDiaLog">
      
      <el-form :model="addAgentForm" :rules="addAgentrules" ref="addAgentFormRef" label-width="80px" class="demo-ruleForm" size="small">
        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="addAgentForm.softName" placeholder="请选择软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="数据key" prop="key" >
          <el-input v-model="addAgentForm.key" clearable placeholder="长度不超过64个字符"></el-input>
        </el-form-item>

        <el-form-item label="数据值" prop="value">
          <el-input type="textarea" v-model="addAgentForm.value" placeholder="长度不超过256个字符" :autosize="{ minRows: 1, maxRows: 4}"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="addAgentForm.remarks" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="createRemoteVar" :loading="state">创 建</el-button>
      </span>
    </el-dialog>

    <!-- 编辑远程数据Dialog -->
    <el-dialog title="编辑远程数据" :close-on-click-modal="false" :visible.sync="integralDialogVisible" :width="addSubWidth" >
      <el-form :model="editRemoteVarForm" :rules="editRemoteVarrules" ref="editRemoteVarRef" label-width="110px" class="demo-ruleForm" size="small">
        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="editRemoteVarForm.softName" placeholder="请选择软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="数据key" prop="key" >
          <el-input v-model="editRemoteVarForm.key" clearable placeholder="长度不超过64个字符"></el-input>
        </el-form-item>

        <el-form-item label="数据值" prop="value">
          <el-input type="textarea" v-model="editRemoteVarForm.value" placeholder="长度不超过256个字符" :autosize="{ minRows: 1, maxRows: 4}"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="editRemoteVarForm.remarks" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="integralBtn">保 存</el-button>
      </span>
    </el-dialog>


    <!-- 删除远程数据dialog -->
    <el-dialog title="确定要删除此远程数据？" :close-on-click-modal="false" :visible.sync="unbindingDialog" :width="agentRightWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>确定要删除此远程数据？</span>
      </div>

      <span style="margin-left:30px">{{editRemoteVarForm.key}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unbindingDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="unbindingDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      addDialogVisible: false,
      addAgentForm:{},
      editRemoteVarForm:{},
      addAgentrules:{
        softName: [
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        key: [
          { required: true, message: "请填写数据名!", trigger: ["blur", "change"] },
          { max: 64,message: "不能超过64个字符!",trigger: ["blur", "change"]},
        ],
        value: [
          { required: true, message: "请填写数据值!", trigger: ["blur", "change"] },
          { max: 256,message: "不能超过256个字符!",trigger: ["blur", "change"]},
        ],
        remarks: [
          { max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ]
      },
      editRemoteVarrules:{
        softName: [
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        key: [
          { required: true, message: "请填写数据名!", trigger: ["blur", "change"] },
          { max: 64,message: "不能超过64个字符!",trigger: ["blur", "change"]},
        ],
        value: [
          { required: true, message: "请填写数据值!", trigger: ["blur", "change"] },
          { max: 256,message: "不能超过256个字符!",trigger: ["blur", "change"]},
        ],
        remarks: [
          { max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ]
      },
      state:false,
      allSoftName:"",

      tableList:[],
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
      },
      total:0,
      integralDialogVisible:false,

      integralForm:{
        action:"购买",
        integral:0
      },
      integralFormrules:{
        action:[
          { required: true, message: "请选择!", trigger: ["blur", "change"] }
        ],
        
      },
      integralInfo:"",
      rightDialogVisible:false,
      upperLimit:false,
      unbindingDialog:false,
      loading:true,
      addAgentWidth:'500px',
      addSubWidth:'500px',
      agentRightWidth:'500px'
    }
  },
  created(){
    this.getCardTypeSoftName()
    this.getRemoteVarList()
    if (document.body.clientWidth < 700){
      this.addAgentWidth = '100%'
      this.addSubWidth = '100%'
      this.agentRightWidth = '100%'
    }
  },
  methods:{
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1);
      var day = date.getDate();
      var hours = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month < 10) { month = '0' + month }
      if (day < 10) { day = '0' + day }
      if (hours < 10) { hours = '0' + hours }
      if (minute < 10) { minute = '0' + minute }
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second;
    },
    //得到远程数据列表
    async getRemoteVarList(){
      //const result = await this.$http.get(`getRemoteVarList?email=${this.$store.state.account}`);
      console.log(this.queryInfo);
      this.state = true
      const result = await this.$http.get("remoteDataList",{
        params:this.queryInfo
      });
      this.state = false;
      console.log('dataresult',result);
      if(result.data.meta.status == 200){
        if (result.data.data.total > 0) {
          this.tableList = result.data.data.result.map(element=>{
            element.createDate = this.$moment(element.createDate).format('YYYY-MM-DD HH:mm:ss')
            element.updateDate = this.$moment(element.updateDate).format('YYYY-MM-DD HH:mm:ss')
            return element
          })
          this.total = result.data.data.total
        }else{
          this.total = 0
          this.tableList = []
        }
      }else{
        this.total = 0
        this.tableList = []
      }
      this.loading = false
    },
    async getCardTypeSoftName(){
      this.state = true
      const result = await this.$http.post("cardGetSoft", {email:this.$store.state.account});
      this.state = false
      //console.log(result);
      this.allSoftName = result.data.data.result.map(element => {
        return element.softName
      })
    },
    addAgentBtn(){
      this.addDialogVisible = true
    },
    refresh(){

    },
    closeAddDiaLog(){
      console.log('关闭了');
      this.$refs.addAgentFormRef.resetFields()
    },
    //创建远程变量
    async createRemoteVar(){
      this.$refs.addAgentFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        this.addAgentForm.email = this.$store.state.account
        const result = await this.$http.post("createRemoteData", this.addAgentForm);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.addDialogVisible = false
        this.$refs.addAgentFormRef.resetFields()
        this.getRemoteVarList()
      })
    },
    refresh(){
      this.getCardTypeSoftName()
      this.getRemoteVarList()
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getRemoteVarList()
    },
    reSet(){
      this.queryInfo.softName = ""
      this.queryInfo.agentEmail = ""
      this.queryInfo.key = ""
      this.$refs.agentRef.resetFields()
      this.getRemoteVarList()
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getRemoteVarList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getRemoteVarList()
    },
    //加减积分
    integral(index){
      this.integralDialogVisible = true
      this.editRemoteVarForm = JSON.stringify(index)
      this.editRemoteVarForm = JSON.parse(this.editRemoteVarForm)
      //console.log(this.editRemoteVarForm);
    },
    integralBtn(){
      this.$refs.editRemoteVarRef.validate(async valid => {
        console.log(valid);
        console.log(this.editRemoteVarForm);
        if(!valid) return
        this.state = true
        this.editRemoteVarForm.email = this.$store.state.account
 
        const result = await this.$http.post("updateRemoteData", this.editRemoteVarForm);
        this.state = false
        console.log('result=>',result);
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.integralDialogVisible = false
        this.$refs.editRemoteVarRef.resetFields()
        this.getRemoteVarList()
      })
    },

    async rightBtn(){
      this.state = true
      this.integralInfo.isUpperLimit = this.upperLimit
      this.integralInfo.email = this.$store.state.account
      const result = await this.$http.post("isUpperLimit", this.integralInfo);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.rightDialogVisible = false
      this.getRemoteVarList()
    },
    unbinding(index){
      this.editRemoteVarForm = index
      this.unbindingDialog = true
    },
    async unbindingDialogBtn(){
      this.state = true
      this.editRemoteVarForm.email = this.$store.state.account
      const result = await this.$http.post("delRemoteData", this.editRemoteVarForm);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.unbindingDialog = false
      this.getRemoteVarList()
    },
    changeInput(e){
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}
.custom{
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-left: 10px;
  }
}
</style>